import { z } from 'zod/v3';
import { encodeClassifierMappingOptionValue } from '../../../../classifier-mapping';
import { encodeAlgorithmSourceDimensionOptionValue } from '../../sources/utils';
import { AlgorithmSourceDimensionFormDataSchema } from '../../sources/schema/AlgorithmSourceFormDataSchema';

export const AlgorithmMappingFormDataSchema = z
  .object({
    mapping: z.object({
      id: z.number(),
      algorithmSourceId: z.number(),
      dataObjectDescriptionCode: z.string().nullish(),
      dataSourceCode: z.string().nullish(),
      classifierMappingId: z.number(),
      classifierMappingCode: z.string(),
      classifierMappingName: z.string(),
      classifierIdFrom: z.number(),
      classifierFromCode: z.string(),
      classifierIdTo: z.number(),
      classifierToCode: z.string(),
      sourceDimension: z.string(),
      alias: z.string(),
      joinTypeCode: z.string(),
    }),
    sourceDimensionsMap: z.map(
      z.number(),
      z.map(z.string(), AlgorithmSourceDimensionFormDataSchema),
    ),
  })
  .transform(
    ({
      mapping: {
        id,
        alias,
        joinTypeCode,
        algorithmSourceId,
        dataObjectDescriptionCode,
        dataSourceCode,
        sourceDimension,
        classifierMappingId,
        classifierMappingCode,
        classifierMappingName,
        classifierToCode,
      },
      sourceDimensionsMap,
    }) => ({
      id,
      alias,
      joinTypeCode,
      classifierToCode,
      sourceDimension: encodeAlgorithmSourceDimensionOptionValue(
        {
          id: algorithmSourceId,
          dataObjectCode: dataObjectDescriptionCode || dataSourceCode,
        },
        {
          code: sourceDimension,
          classifier: sourceDimensionsMap
            .get(algorithmSourceId)
            ?.get(sourceDimension)?.classifier,
        },
      ),
      classifierMapping: encodeClassifierMappingOptionValue({
        id: classifierMappingId,
        code: classifierMappingCode,
        name: classifierMappingName,
      }),
    }),
  );
